// import i18next from "i18next";
import { Multilingual } from "gql/generated.ts";

export const updateMultilingual = (
  multilingual: Multilingual,
  input: string,
) => {
  // const lang = (
  //   i18next.language && i18next.language in multilingual
  //     ? i18next.language
  //     : "en"
  // ) as keyof typeof multilingual;
  const lang = "en"; // Currently only using "en" as the lang

  if (input.length === 0) {
    return { ...multilingual, en: "", es: "", fr: "" } as Multilingual;
  }

  return { ...multilingual, [lang]: input } as Multilingual;
};
